import { Select, Form } from 'antd'
import styles from './styles.module.scss'
import { removeVietnameseTones } from '../../../config-func';
const SelectField = ({
  label,
  name,
  options = [],
  placeholder = '',
  required = false,
  rules = [],
  onChange,
  showSearch = true,
  allowClear = true,
  labelRequired = '',
  mode,
  hasAllOption = false, // Thêm tùy chọn hiển thị "Tất cả"
  ...rest // Nhận
}) => {

  const updatedOptions = hasAllOption ? [{ value: "", label: "Tất cả" }, ...options] : options;


  return (
    <Form.Item
      label={label}
      name={name}
      required={required}
      rules={[
        ...(required
          ? [
              {
                validator: (_, value) => {
                  if (value === "" || value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(`Vui lòng chọn ${labelRequired || label.toLowerCase()}`);
                }
              }
            ]
          : []),
        ...rules
      ]}
      className={styles.formItem}
    >
      <Select
        mode={mode}
        placeholder={placeholder || `Chọn ${label.toLowerCase()}`}
        onChange={onChange}
        showSearch={showSearch}
        allowClear={allowClear}
        filterOption={(input, option) => {
          const inputValue = removeVietnameseTones(input).toLowerCase();
          const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
          return optionValue.includes(inputValue);
        }}
        {...rest}
      >
        {updatedOptions.map((item) => (
          <Select.Option key={item.value} value={item.value}>
            {item.label}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  )
}

export default SelectField
